module.exports = __webpack_public_path__ + "static/media/Brochure.80317395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductLandingPage/images/Brochure.svg
// module id = 1018
// module chunks = 0